import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { PapiDeviation } from '@wix/da-papi-types';
import biLogger from '@wix/da-bi/pkg/BiLogger.logger';
import { PureBiData, BiEvent, VideoPlayerActionBiEvent } from '@wix/da-bi/pkg/events';
import { getBiEventComponentByType } from '../../../DeviationPage/redux/helpers';
import { getPublicSession } from '../../../publicSession/selectors';
import { getDeviationType } from '../../_helpers';

export type VideoPlayerAction =
  | 'play'
  | 'pause'
  | 'timeupdate'
  | 'volumechange'
  | 'sourcechange'
  | 'enterfullscreen'
  | 'exitfullscreen'
  | 'ended';

export function useVideoPlayerActionBiLogger(
  deviation: PapiDeviation
): (action: VideoPlayerAction) => void {
  const publicSession = useSelector(getPublicSession, () => true);
  const deviationId = deviation.deviationId;
  const isPublished = deviation.isPublished;
  const deviationType = getDeviationType(deviation);

  return useCallback(
    (action: VideoPlayerAction) => {
      const event: BiEvent = PureBiData<VideoPlayerActionBiEvent>({
        evid: 311,
        view: isPublished ? 'submission' : 'stash',
        component: getBiEventComponentByType(deviationType),
        deviationid: deviationId,
        action,
      });

      void biLogger.log(publicSession, event);
    },
    [deviationId, isPublished, publicSession, deviationType]
  );
}
